import {
    KEYCLOAK,
    KEYCLOAK_SUCCESS,
    KEYCLOAK_ERROR
} from '../constants/keyCloakConstants';

//#region SET KEYCLOAK 
export function setKeyCloak(data) {
    return {
        type: KEYCLOAK,
        data
    }
};

export function setKeyCloakSuccess(data) {
    return {
        type: KEYCLOAK_SUCCESS,
        data
    }
};

export function setKeyCloakError(data) {
    return {
        type: KEYCLOAK_ERROR,
        data
    }
};

export function SetKeyCloak(keyCloak) {
    return dispatch => {
        dispatch(setKeyCloak());

        dispatch(setKeyCloakSuccess(keyCloak))
                  
    }
};

//#endregion